<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'




//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'



//data
import { getAuditLogsByDoc } from '@/services/serviceAuditLogs';

//utils
import { checkFields } from '@/utils/auditLogs';

export default defineComponent({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'AuditLog',
	mixins: [MixinGeneralFunct],
	components: {
		LoadingScreen
		, Alert

	},
	props: { 'currentDoc': Object, 'date': String, 'typeId': String, 'docId': String, 'auth': Object, 'secData': Object, 'modalObject': Object, 'modalId': String },
	emits: ["date", "changeRecord"],
	data() {
		return {
			prefix: '',

			metaData: [],

			menuItems: [],
			isLoading: false,

			selectedPage: 1,
			selectedRecords: 10,
			selectedCol: 'a.id',
			selectedSort: 'desc',

			filterExtended: false,
			showFilter: false,

			totalCount: 0,
			dataList: [],

			docToView: {},

			user: [],
			selectedFilterText: ''
		}
	},

	mounted: function () {

	},

	methods: {
		// load data form
		onLoadPage: function () {

			this.isLoading = true

			getAuditLogsByDoc({ docId: this.docId, date: this.date }).then(response => {
				if (!response.statusText) {
					this.isLoading = false
					this.dataList = response.results;

				} else {
					this.isLoading = false
					this.errorStatus = `${response.statusText} ${response.status}`
				}
			});



		},


		onClose: function () {
			this.modalObject.hide();
		},



	},

	watch: {
		date() {
			this.onLoadPage();
		},
		dataList() {

			let doc = this.currentDoc;
			/*for (const key1 of Object.keys(this.currentDoc)) {
				if(!checkFields(key1, this.typeId)){
					doc[key1] = this.currentDoc[key1];
				}
			}*/
			console.log(doc)
			let viewDoc = {};

			const auditLog = this.dataList;

			for (const log of auditLog) {

				const objDiffs = JSON.parse(log.string)
				console.log(objDiffs)

				for (const keyDoc of Object.keys(doc)) {
					if (!checkFields(keyDoc, this.typeId)) {
						delete doc.keyDoc;
					}
				}

				for (const key of Object.keys(objDiffs)) {

					if (!checkFields(key, this.typeId)) {

						let value = '';
						let valueView = '';

						for (const diff of objDiffs[key]) {

							if (diff.added) {
								valueView += `<span class="text-success">${diff.value}</span>`;

							} else if (diff.removed) {
								value += `${diff.value}`;
								valueView += `<span class="text-danger">${diff.value}</span>`;

							} else if (Number(diff.start) >= 0 && diff.end) {

								if (key === "components") {
									value += JSON.stringify(doc[key])?.substring(diff.start, diff.end);
									valueView += JSON.stringify(doc[key])?.substring(diff.start, diff.end);
								} else if (key !== "state") {
									value += String(doc[key])?.substring(diff.start, diff.end);
									valueView += String(doc[key])?.substring(diff.start, diff.end);
								} else {
									value += doc[key];
									valueView += doc[key];
								}

							}

						}

						if (valueView !== '') {
							viewDoc = ({ ...viewDoc, [key]: valueView });
						}

						if (value !== '') {
							doc = ({ ...doc, [key]: value });
						}

					}

				}

				this.docToView = viewDoc;
			}


		}
	},

	computed: {

	},

})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1">
			<div class="modal-dialog modal-dialog-scrollable modal-fullscreen">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCore.AuditLogs') }} <b><span></span></b></h6>
					</div>

					<div v-if="auth.usersShowSysLogData" class="modal-body">

						<div class="row">
							<div class="col-12">
								{{ date }}
							</div>
						</div>

						<div v-for="(val, name) in docToView" :key="val">
							<div class="row">
								<div class="col-md-2 col-12">
									<div>{{ name }}</div>
								</div>
								<div class="col-md-10 col-12">
									<div v-html="val"></div>
								</div>
							</div>
						</div>

					</div>

					<div v-else class="modal-body">
						<div class="row">
							<div class="col-12 mt-3">
								<Alert type="warning" :label="$t('msgCore.accessDenied')" />
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<div class="btn-group">
							<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose')
							}}</button>
						</div>
					</div>

				</div>

			</div>

		</div>
	</div>
</template>


